import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import img1 from "../../assets/images/about/image1.png";
import img2 from "../../assets/images/about/image2.png";
import img3 from "../../assets/images/about/image3.png";
import img4 from "../../assets/images/about/image4.png";
import { FaLinkedin, FaXTwitter } from "react-icons/fa6";
import ContactFooter from "../../components/ContactFooter";

const aboutPeople = [
  {
    name: "Dr. Ralph Horwitz",
    image: img1,
    designation: "Co-founder",
    description:
      "Former Chair of Medicine at Yale and Stanford, Dean at Case Western, Practicing academic physician (35+ years,) SVP at GSK",
    college: "American College of Physicians, MACP",
    // twitter: "https://www.linkedin.com/in/ralph-horwitz-733b3126/",
    linkedin: "https://www.linkedin.com/in/ralph-horwitz-733b3126/",
  },
  {
    name: "James Baker",
    image: img3,
    designation: "Co-founder",
    description:
      "Former Expert in Al and Lead Data Scientist McKinsey Life Sciences practice; Columbia Biomedical Informatics PhD student",
    college: "Yale University, B.A. Applied Mathematics",
    twitter: "https://x.com/jamesbbaker4",
    linkedin: " https://www.linkedin.com/in/james-baker-b1a0259b/",
  },
  {
    name: "Dr. Arnie Ghatak",
    image: img2,
    designation: "Co-founder",
    description:
      "Former Senior Partner at McKinsey (20+ yrs); Global head of Medical Affairs (8+ yrs); Recently Head of Strategy and Innovation at Public Biotech",
    college:
      "University of Pennsylvania, MD, MBA Princeton University, A.B. Molecular Biology",
    // twitter: "https://www.linkedin.com/in/arnie-ghatak/",
    linkedin: "https://www.linkedin.com/in/arnie-ghatak/",
  },
  {
    name: "Dr. Mark Cullen",
    image: img4,
    designation: "Sr Clinical Advisor",
    description:
      "Former Dean for Research of Stanford Medical School, Chief Division of General Medicine, Director of Stanford Center for Population Health Sciences",
    college: "Yale University Medical School, MD Harvard University, A.B.",
    // twitter: "https://www.linkedin.com/in/mark-cullen-35b99224/",
    linkedin: "https://www.linkedin.com/in/mark-cullen-35b99224/",
  },
];

export default function About() {
  return (
    <>
      <Navbar />
      <div className="min-h-screen py-4 pt-24 md:pt-32 md:max-w-[90%] mx-auto bg-white">
        <h1 
          className="md:text-5xl md:px-0 px-10 text-2xl border-b-2 pb-6 pt-4 font-medium"
          style={{ color: '#0f172a', borderColor: '#e2e8f0' }}
        >
          About Us
        </h1>
        <p 
          className="pt-4 md:px-0 px-10 md:text-xl text-base leading-relaxed"
          style={{ color: '#475569' }}
        >
          Clinica AI develops first-in-class digital software to empower
          healthcare leaders to improve the care of patients by using RWD and AI
          to crack previously unsolvable problems
        </p>
        <div className="grid mt-16 md:grid-cols-4 grid-cols-1 gap-8 px-10 md:px-0">
          {aboutPeople.map((item, index) => (
            <div 
              key={index} 
              className="flex text-center mb-12 cursor-pointer flex-col items-center gap-3 p-4 rounded-lg hover:bg-gray-50 transition-colors"
            >
              <img src={item.image} alt={item.name} className="rounded-full w-32 h-32 object-cover" />
              <div className="flex flex-col gap-2 items-center text-center">
                <h2 className="font-semibold text-xl" style={{ color: '#0f172a' }}>{item.name}</h2>
                <p className="text-sm font-medium" style={{ color: '#3b82f6' }}>{item.designation}</p>
                <p className="text-sm leading-relaxed" style={{ color: '#475569' }}>{item.description}</p>
                <p className="text-sm" style={{ color: '#64748b' }}>{item.college}</p>
                <div className="flex mt-3 items-center gap-4">
                  <a 
                    target="_blank" 
                    rel="noreferrer" 
                    href={item.linkedin} 
                    className="hover:opacity-80 transition-opacity"
                    style={{ color: '#2563eb' }}
                  >
                    <FaLinkedin size={28} />
                  </a>
                  {item.twitter && (
                    <a 
                      target="_blank" 
                      rel="noreferrer" 
                      href={item.twitter} 
                      className="hover:opacity-80 transition-opacity"
                      style={{ color: '#0f172a' }}
                    >
                      <FaXTwitter size={28} />
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <ContactFooter />
      <Footer />
    </>
  );
}
